import { SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import spacesBase, { UnknownSlugWorkaround } from "./spacesBase";

const spaceVS: SpaceConfig = {
    ...spacesBase,
    id: SpaceId.VS,
    displayName: "Visual Studio",
    slug: UnknownSlugWorkaround,
    spaceTag: { type: "tag", value: "visual-studio" },
    reportProblemConfig: {
        ...spacesBase.reportProblemConfig,
        isNativeProcessRequired: true,
    },
    reportSuggestionConfig: {
        ...spacesBase.reportSuggestionConfig,
        isNativeProcessRequired: false,
    },
};

export default spaceVS;
